import {buildTimestamp} from '@/helpers/dateUtils'

export const useTimePicker = (validationRules = []) => {
  const isInvalidTime = time => {
    if (!time || time.length === 0) return false

    const digitsOnly = time.replace(/:/g, '')

    if (digitsOnly.length >= 2) {
      const hours = parseInt(digitsOnly.slice(0, 2), 10)
      if (hours > 23) return true
    }

    if (digitsOnly.length >= 4) {
      const minutes = parseInt(digitsOnly.slice(2, 4), 10)
      if (minutes > 59) return true
    }

    if (time.length >= 5) {
      return !/^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/.test(time)
    }

    return false
  }

  const cleanValue = time => {
    if (!time || time.length === 0) return time

    const digitsOnly = time.replace(/:/g, '')

    if (digitsOnly.length >= 3) {
      return digitsOnly.slice(0, 2) + ':' + digitsOnly.slice(2, 4)
    }

    return digitsOnly
  }

  // end time should be greater than start time if they are on the same day
  const validateStartandEndTime = selectedTime => {
    if (!selectedTime) return ''

    const endTimeRule = validationRules.find(rule => rule.type === 'endTime')
    if (!endTimeRule) return ''

    if (endTimeRule.startTime && endTimeRule.startDate && endTimeRule.endDate) {
      const startTimestamp = buildTimestamp(endTimeRule.startDate, endTimeRule.startTime)
      const endTimestamp = buildTimestamp(endTimeRule.endDate, selectedTime)

      if (endTimestamp <= startTimestamp) {
        return 'Active end time must be after start time'
      }
    }
    return ''
  }

  return {
    validateStartandEndTime,
    cleanValue,
    isInvalidTime,
  }
}
